<template>
  <TwinPanel title="Verify your email address">
    <template v-slot:form>
      <LoadingWrapper :loading-bool="submitting">
        <div v-if="success">
          Your email is now verified! <a href="/sites/">Get back to your evaluations</a>.
        </div>
        <div v-if="!success">
          Uh-oh, something went awry:
          <b-alert v-for="error in errors" :key="error" show variant="danger" class="mt-2">
            {{ error }}
          </b-alert>
          You can request another verification <a href="/user/details/">here</a> or
          reach out for more support <a href="mailto:info@heurix.io">here.</a>
        </div>
      </LoadingWrapper>
    </template>
    <template v-slot:text>
      <h4>
        Heurix is currently in Beta so let us know how we can improve things for you.
        You can <a href="mailto:info@heurix.io">email us</a> or use the feedback popup once
        you log in.
      </h4>
    </template>
  </TwinPanel>
</template>


<style lang="scss" scoped>
  .form {
    margin: 0 auto;
    max-width: 550px;

    input, button {
      height: 3em;
      width: 100%;
    }

    button:disabled, button {
      background-color: #ff583b;
      border-color: #ff583b;
    }
  }
</style>

<script>
  import apiMixin from "../../utils/api"
  import TwinPanel from "./utils/TwinPanel"
  import LoadingWrapper from "../navigation/LoadingWrapper"

  export default {
    name: 'UserRegister',
    components: {LoadingWrapper, TwinPanel},
    mixins: [apiMixin],
    props: {
      uid: {
        type: String,
        required: true
      },
      token: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        errors: [],
        submitting: false,
        success: false
      }
    },
    methods: {
      async load() {
        await this.withLoading(async () => {
          try {
            const {uid, token} = this
            await this.post(`/api/users/verification/`, {uid, token})
            this.success = true
          } catch (e) {
            this.catchApiError(e, false)
          }
        }, 'submitting')
      },
    }
  }
</script>
